if (!customElements.get("swiper-swiper")) {
  customElements.define(
    "swiper-swiper",
    class SwiperSwiper extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector(".swiper");
        this.id = this.dataset.id;

        this.initSlider();
      }

      initSlider() {
        const slider = new Swiper(`.swiper`, {
          slidesPerView: this.dataset.colMobile,
          spaceBetween: 10,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          pagination: false,
          navigation: false,
          centeredSlides: true,
          loop: "infinite",
          autoHeight: false,
          autoplay: false,
          breakpoints: {
            750: {
              slidesPerView: this.dataset.colTablet,
              spaceBetween: 30,
            },
            990: {
              slidesPerView: this.dataset.colDesktop,
              spaceBetween: 30,
            },
          },
        });
      }
    }
  );
}
